/**
 * hero-anchor-scroll.js
 * Smooth-scrolls hero CTA buttons whose link is an in-page anchor (#section-id)
 * to their target, offset by the sticky header's live bottom edge so the target
 * isn't hidden behind the pinned header. Buttons opt in via [data-anchor-scroll],
 * emitted by hero-content.liquid only when the button URL starts with '#'.
 *
 * Delegated on document with a one-time init guard, so multiple hero instances
 * (and theme-editor section reloads, which re-inject this script) never
 * double-bind. The header-offset logic mirrors page-nav.js.
 */
(function () {
  'use strict';

  if (window.__heroAnchorScrollInit) return;
  window.__heroAnchorScrollInit = true;

  var SCROLL_GAP = 20; // px breathing room below the pinned header

  function headerOffset() {
    var header = document.querySelector('.header--sticky');
    if (!header) return 0;
    // Live bottom edge, not height: the announcement region can slide away on
    // scroll-down without changing the header's height, so reading .bottom keeps
    // the offset flush to whatever of the header is actually still on screen.
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function resolveTarget(href) {
    if (!href || href.charAt(0) !== '#' || href.length < 2) return null;
    try {
      return document.querySelector(href);
    } catch {
      return null;
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-anchor-scroll]');
    if (!link) return;
    var target = resolveTarget(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    // Browsers honour prefers-reduced-motion automatically for behavior:'smooth',
    // so no extra branch is needed.
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - SCROLL_GAP;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (window.history && history.pushState) {
      history.pushState(null, '', link.getAttribute('href'));
    }
  });
})();
